// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");
var PlaybackValues$SmartcutsMacros = require("./PlaybackValues.bs.js");
var UserCredential$SmartcutsMacros = require("./UserCredential.bs.js");
var PlaybackOptions$SmartcutsMacros = require("./PlaybackOptions.bs.js");
var Browser__Identity$SmartcutsMacros = require("./browser/Browser__Identity.bs.js");
var GoogleSheetHelpers$SmartcutsMacros = require("./GoogleSheetHelpers.bs.js");
var PlaybackParamValue$SmartcutsMacros = require("./PlaybackParamValue.bs.js");

function multiUrlTriggeringTrigger_encode(v) {
  if (v) {
    return ["PopupMultiUrlTrigger"];
  } else {
    return ["ContextMenuMultiUrlTrigger"];
  }
}

function multiUrlTriggeringTrigger_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContextMenuMultiUrlTrigger" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContextMenuMultiUrlTrigger */0
                  };
          }
      case "PopupMultiUrlTrigger" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PopupMultiUrlTrigger */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "trigger",
                multiUrlTriggeringTrigger_encode(v.trigger)
              ],
              [
                "credentialDbIdsByHostname",
                CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(UserCredential$SmartcutsMacros.DbId.id_encode, v.credentialDbIdsByHostname)
              ],
              [
                "hrefs",
                Decco.arrayToJson(Decco.stringToJson, v.hrefs)
              ],
              [
                "paramValuesByCommandIndex",
                PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v.paramValuesByCommandIndex)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var trigger = multiUrlTriggeringTrigger_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
  if (trigger.TAG === /* Ok */0) {
    var credentialDbIdsByHostname = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(UserCredential$SmartcutsMacros.DbId.id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialDbIdsByHostname"), null));
    if (credentialDbIdsByHostname.TAG === /* Ok */0) {
      var hrefs = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hrefs"), null));
      if (hrefs.TAG === /* Ok */0) {
        var paramValuesByCommandIndex = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paramValuesByCommandIndex"), null));
        if (paramValuesByCommandIndex.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    trigger: trigger._0,
                    credentialDbIdsByHostname: credentialDbIdsByHostname._0,
                    hrefs: hrefs._0,
                    paramValuesByCommandIndex: paramValuesByCommandIndex._0
                  }
                };
        }
        var e = paramValuesByCommandIndex._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".paramValuesByCommandIndex" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = hrefs._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".hrefs" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = credentialDbIdsByHostname._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".credentialDbIdsByHostname" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = trigger._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".trigger" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function toArrayOfPlaybackValues(param) {
  var paramValuesByCommandIndex = param.paramValuesByCommandIndex;
  return Belt_Array.map(param.hrefs, (function (href) {
                return Belt_MapInt.update(paramValuesByCommandIndex, 0, (function (maybePlaybackParamValue) {
                              return Belt_Option.map(maybePlaybackParamValue, (function (paramValue) {
                                            if (paramValue.TAG === /* URLParamValue */5) {
                                              return {
                                                      TAG: /* URLParamValue */5,
                                                      _0: {
                                                        url: href,
                                                        urlCommandType: paramValue._0.urlCommandType
                                                      }
                                                    };
                                            } else {
                                              return paramValue;
                                            }
                                          }));
                            }));
              }));
}

var MultiUrlTriggeringWithCreds = {
  t_encode: t_encode,
  t_decode: t_decode,
  toArrayOfPlaybackValues: toArrayOfPlaybackValues
};

function failedState_encode(v) {
  return Js_dict.fromArray([
              [
                "failedReason",
                failedReason_encode(v.failedReason)
              ],
              [
                "numCompleted",
                Decco.intToJson(v.numCompleted)
              ]
            ]);
}

function googleSheet_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var spreadsheetUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetUrl"), null));
    if (spreadsheetUrl.TAG === /* Ok */0) {
      var spreadsheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetName"), null));
      if (spreadsheetName.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  spreadsheetId: spreadsheetId._0,
                  spreadsheetUrl: spreadsheetUrl._0,
                  spreadsheetName: spreadsheetName._0
                }
              };
      }
      var e = spreadsheetName._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".spreadsheetName" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = spreadsheetUrl._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".spreadsheetUrl" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function failedState_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var failedReason = failedReason_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedReason"), null));
  if (failedReason.TAG === /* Ok */0) {
    var numCompleted = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCompleted"), null));
    if (numCompleted.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                failedReason: failedReason._0,
                numCompleted: numCompleted._0
              }
            };
    }
    var e = numCompleted._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numCompleted" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = failedReason._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".failedReason" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function googleSheet_encode(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "spreadsheetUrl",
                Decco.stringToJson(v.spreadsheetUrl)
              ],
              [
                "spreadsheetName",
                Decco.stringToJson(v.spreadsheetName)
              ]
            ]);
}

function failedReason_encode(v) {
  switch (v) {
    case /* DidRejectPermission */0 :
        return ["DidRejectPermission"];
    case /* DidNotGetOAuthTokenForGSheet */1 :
        return ["DidNotGetOAuthTokenForGSheet"];
    case /* CouldNotFindGoogleSheet */2 :
        return ["CouldNotFindGoogleSheet"];
    case /* ErrorWhileFetchingGoogleSheet */3 :
        return ["ErrorWhileFetchingGoogleSheet"];
    case /* UnableToDecodeSmartcutParams */4 :
        return ["UnableToDecodeSmartcutParams"];
    
  }
}

function failedReason_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CouldNotFindGoogleSheet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CouldNotFindGoogleSheet */2
                  };
          }
      case "DidNotGetOAuthTokenForGSheet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotGetOAuthTokenForGSheet */1
                  };
          }
      case "DidRejectPermission" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidRejectPermission */0
                  };
          }
      case "ErrorWhileFetchingGoogleSheet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ErrorWhileFetchingGoogleSheet */3
                  };
          }
      case "UnableToDecodeSmartcutParams" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UnableToDecodeSmartcutParams */4
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function dataSource_encode(v) {
  switch (v.TAG | 0) {
    case /* Form */0 :
        return [
                "Form",
                PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v._0)
              ];
    case /* GoogleSheet */1 :
        return [
                "GoogleSheet",
                googleSheet_encode(v._0)
              ];
    case /* MultiUrlTriggering */2 :
        return [
                "MultiUrlTriggering",
                multiUrlTriggeringTrigger_encode(v._0),
                Decco.arrayToJson(PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode, v._1)
              ];
    case /* FormWithCreds */3 :
        return [
                "FormWithCreds",
                PlaybackValues$SmartcutsMacros.t_encode(v._0)
              ];
    case /* MultiUrlTriggeringWithCreds */4 :
        return [
                "MultiUrlTriggeringWithCreds",
                t_encode(v._0)
              ];
    
  }
}

function status_encode(v) {
  if (typeof v !== "number") {
    return [
            "Failed",
            failedState_encode(v._0)
          ];
  }
  switch (v) {
    case /* Created */0 :
        return ["Created"];
    case /* Queued */1 :
        return ["Queued"];
    case /* InProgress */2 :
        return ["InProgress"];
    case /* Cancelled */3 :
        return ["Cancelled"];
    case /* Finished */4 :
        return ["Finished"];
    
  }
}

function status_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Cancelled" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Cancelled */3
                  };
          }
      case "Created" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Created */0
                  };
          }
      case "Failed" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = failedState_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Failed */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Finished" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Finished */4
                  };
          }
      case "InProgress" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* InProgress */2
                  };
          }
      case "Queued" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Queued */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function dataSource_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Form" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Form */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FormWithCreds" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = PlaybackValues$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FormWithCreds */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "GoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GoogleSheet */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "MultiUrlTriggering" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = multiUrlTriggeringTrigger_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.arrayFromJson(PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* MultiUrlTriggering */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$3 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "MultiUrlTriggeringWithCreds" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MultiUrlTriggeringWithCreds */4,
                      _0: v0$3._0
                    }
                  };
          }
          var e$5 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "dataSource",
                dataSource_encode(v.dataSource)
              ],
              [
                "name",
                Decco.optionToJson(Decco.stringToJson, v.name)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "createdAt",
                Decco.floatToJson(v.createdAt)
              ],
              [
                "playbackOptions",
                Decco.optionToJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode, v.playbackOptions)
              ],
              [
                "status",
                status_encode(v.status)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var dataSource = dataSource_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSource"), null));
    if (dataSource.TAG === /* Ok */0) {
      var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
        if (installedSmartcutId.TAG === /* Ok */0) {
          var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
          if (createdAt.TAG === /* Ok */0) {
            var playbackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptions"), null));
            if (playbackOptions.TAG === /* Ok */0) {
              var status = status_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
              if (status.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          id: id._0,
                          dataSource: dataSource._0,
                          name: name._0,
                          installedSmartcutId: installedSmartcutId._0,
                          createdAt: createdAt._0,
                          playbackOptions: playbackOptions._0,
                          status: status._0
                        }
                      };
              }
              var e = status._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".status" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = playbackOptions._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".playbackOptions" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = createdAt._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".createdAt" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = installedSmartcutId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".installedSmartcutId" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = dataSource._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dataSource" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function stringifyStatus(status) {
  if (typeof status !== "number") {
    return "Failed(" + status._0 + ")";
  }
  switch (status) {
    case /* Created */0 :
        return "Created";
    case /* Queued */1 :
        return "Queued";
    case /* InProgress */2 :
        return "InProgress";
    case /* Cancelled */3 :
        return "Cancelled";
    case /* Finished */4 :
        return "Finished";
    
  }
}

function stringifyMultiUrlTriggeringTrigger(trigger) {
  if (trigger) {
    return "PopupMultiUrlTrigger";
  } else {
    return "ContextMenuMultiUrlTrigger";
  }
}

function getNameOrHumanizedAlias(param) {
  var name = param.name;
  if (name !== undefined) {
    return name;
  }
  switch (param.dataSource.TAG | 0) {
    case /* GoogleSheet */1 :
        return "Google Sheets Execution";
    case /* Form */0 :
    case /* FormWithCreds */3 :
        return "Smartcuts Form Execution";
    case /* MultiUrlTriggering */2 :
    case /* MultiUrlTriggeringWithCreds */4 :
        return "Multi URL Execution";
    
  }
}

function make(dataSource, installedSmartcutId, status, userSpecifiedPlaybackOptions, maybeId, maybeName, param) {
  return {
          id: OptionUtils$SmartcutsMacros.withDefault(Uuid.v1(), maybeId),
          dataSource: dataSource,
          name: maybeName,
          installedSmartcutId: installedSmartcutId,
          createdAt: Date.now(),
          playbackOptions: userSpecifiedPlaybackOptions,
          status: status
        };
}

function size(param) {
  var dataSource = param.dataSource;
  switch (dataSource.TAG | 0) {
    case /* GoogleSheet */1 :
        var spreadsheetId = dataSource._0.spreadsheetId;
        return Browser__Identity$SmartcutsMacros.getAuthToken(true, true, undefined, undefined, undefined).then(function (maybeAccessToken) {
                    var arg = Belt_Option.map(maybeAccessToken, (function (accessToken) {
                            return GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined).then(function (client) {
                                        return GoogleSheetHelpers$SmartcutsMacros.getSpreadsheetSize_withEdgeCaseHandling(spreadsheetId, accessToken, undefined, client);
                                      });
                          }));
                    var param = Promise.resolve(-1);
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                  });
    case /* MultiUrlTriggering */2 :
        return Promise.resolve(dataSource._1.length);
    case /* Form */0 :
    case /* FormWithCreds */3 :
        return Promise.resolve(1);
    case /* MultiUrlTriggeringWithCreds */4 :
        return Promise.resolve(dataSource._0.hrefs.length);
    
  }
}

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "googleSheet",
                googleSheet_encode(v.googleSheet)
              ],
              [
                "name",
                Decco.optionToJson(Decco.stringToJson, v.name)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "createdAt",
                Decco.floatToJson(v.createdAt)
              ],
              [
                "playbackOptions",
                Decco.optionToJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode, v.playbackOptions)
              ],
              [
                "status",
                status_encode(v.status)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var googleSheet = googleSheet_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "googleSheet"), null));
    if (googleSheet.TAG === /* Ok */0) {
      var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
        if (installedSmartcutId.TAG === /* Ok */0) {
          var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
          if (createdAt.TAG === /* Ok */0) {
            var playbackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptions"), null));
            if (playbackOptions.TAG === /* Ok */0) {
              var status = status_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
              if (status.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          id: id._0,
                          googleSheet: googleSheet._0,
                          name: name._0,
                          installedSmartcutId: installedSmartcutId._0,
                          createdAt: createdAt._0,
                          playbackOptions: playbackOptions._0,
                          status: status._0
                        }
                      };
              }
              var e = status._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".status" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = playbackOptions._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".playbackOptions" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = createdAt._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".createdAt" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = installedSmartcutId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".installedSmartcutId" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = googleSheet._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".googleSheet" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function minify(x) {
  return x;
}

function toExecutionSet(param) {
  return {
          id: param.id,
          dataSource: {
            TAG: /* GoogleSheet */1,
            _0: param.googleSheet
          },
          name: param.name,
          installedSmartcutId: param.installedSmartcutId,
          createdAt: param.createdAt,
          playbackOptions: param.playbackOptions,
          status: param.status
        };
}

var ForGoogleSheet = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  minify: minify,
  toExecutionSet: toExecutionSet
};

var ExecutionSet = {
  multiUrlTriggeringTrigger_encode: multiUrlTriggeringTrigger_encode,
  multiUrlTriggeringTrigger_decode: multiUrlTriggeringTrigger_decode,
  MultiUrlTriggeringWithCreds: MultiUrlTriggeringWithCreds,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  dataSource_encode: dataSource_encode,
  dataSource_decode: dataSource_decode,
  googleSheet_encode: googleSheet_encode,
  googleSheet_decode: googleSheet_decode,
  status_encode: status_encode,
  status_decode: status_decode,
  failedState_encode: failedState_encode,
  failedState_decode: failedState_decode,
  failedReason_encode: failedReason_encode,
  failedReason_decode: failedReason_decode,
  stringifyStatus: stringifyStatus,
  stringifyMultiUrlTriggeringTrigger: stringifyMultiUrlTriggeringTrigger,
  getNameOrHumanizedAlias: getNameOrHumanizedAlias,
  make: make,
  size: size,
  ForGoogleSheet: ForGoogleSheet
};

function errorDetails_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "SelectorFailure" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectorFailure */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "UnknownError" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UnknownError */1
                  };
          }
      case "UserStoppedPlayback" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UserStoppedPlayback */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function error_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var failedStepIndex = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedStepIndex"), null));
  if (failedStepIndex.TAG === /* Ok */0) {
    var errorDetails = errorDetails_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "errorDetails"), null));
    if (errorDetails.TAG === /* Ok */0) {
      var resolved = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resolved"), null));
      if (resolved.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  failedStepIndex: failedStepIndex._0,
                  errorDetails: errorDetails._0,
                  resolved: resolved._0
                }
              };
      }
      var e = resolved._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".resolved" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = errorDetails._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".errorDetails" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = failedStepIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".failedStepIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function errorDetails_encode(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["UnknownError"];
    } else {
      return ["UserStoppedPlayback"];
    }
  } else {
    return [
            "SelectorFailure",
            Selector$SmartcutsMacros.selector_encode(v._0)
          ];
  }
}

function error_encode(v) {
  return Js_dict.fromArray([
              [
                "failedStepIndex",
                Decco.optionToJson(Decco.intToJson, v.failedStepIndex)
              ],
              [
                "errorDetails",
                errorDetails_encode(v.errorDetails)
              ],
              [
                "resolved",
                Decco.boolToJson(v.resolved)
              ]
            ]);
}

function status_encode$1(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["ExitedWithSuccess"];
    } else {
      return ["Running"];
    }
  } else {
    return [
            "ExitedWithError",
            error_encode(v._0)
          ];
  }
}

function status_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ExitedWithError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = error_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExitedWithError */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ExitedWithSuccess" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExitedWithSuccess */1
                  };
          }
      case "Running" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Running */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "taskId",
                Decco.stringToJson(v.taskId)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "createdAt",
                Decco.floatToJson(v.createdAt)
              ],
              [
                "playbackValues",
                PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__encode(v.playbackValues)
              ],
              [
                "credentialDbIdsByHostname",
                Decco.optionToJson((function (param) {
                        return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(UserCredential$SmartcutsMacros.DbId.id_encode, param);
                      }), v.credentialDbIdsByHostname)
              ],
              [
                "status",
                status_encode$1(v.status)
              ],
              [
                "failureId",
                Decco.optionToJson(Decco.stringToJson, v.failureId)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var taskId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "taskId"), null));
    if (taskId.TAG === /* Ok */0) {
      var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
      if (installedSmartcutId.TAG === /* Ok */0) {
        var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
        if (createdAt.TAG === /* Ok */0) {
          var playbackValues = PlaybackParamValue$SmartcutsMacros.ValuesByCommandIndex.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackValues"), null));
          if (playbackValues.TAG === /* Ok */0) {
            var credentialDbIdsByHostname = Decco.optionFromJson((function (param) {
                    return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(UserCredential$SmartcutsMacros.DbId.id_decode, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialDbIdsByHostname"), null));
            if (credentialDbIdsByHostname.TAG === /* Ok */0) {
              var status = status_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
              if (status.TAG === /* Ok */0) {
                var failureId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureId"), null));
                if (failureId.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            id: id._0,
                            taskId: taskId._0,
                            installedSmartcutId: installedSmartcutId._0,
                            createdAt: createdAt._0,
                            playbackValues: playbackValues._0,
                            credentialDbIdsByHostname: credentialDbIdsByHostname._0,
                            status: status._0,
                            failureId: failureId._0
                          }
                        };
                }
                var e = failureId._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".failureId" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = status._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".status" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = credentialDbIdsByHostname._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".credentialDbIdsByHostname" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = playbackValues._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".playbackValues" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = createdAt._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".createdAt" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = installedSmartcutId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".installedSmartcutId" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = taskId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".taskId" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function makeWithId(id, executionSetId, installedSmartcutId, playbackValues) {
  return {
          id: id,
          taskId: executionSetId,
          installedSmartcutId: installedSmartcutId,
          createdAt: Date.now(),
          playbackValues: PlaybackValues$SmartcutsMacros.getSmartcutParamValuesByCommandIndex(playbackValues),
          credentialDbIdsByHostname: Caml_option.some(playbackValues.credentialDbIdsByHostname),
          status: /* Running */0,
          failureId: undefined
        };
}

function make$1(executionSetId, installedSmartcutId, playbackValues) {
  return {
          id: Uuid.v1(),
          taskId: executionSetId,
          installedSmartcutId: installedSmartcutId,
          createdAt: Date.now(),
          playbackValues: PlaybackValues$SmartcutsMacros.getSmartcutParamValuesByCommandIndex(playbackValues),
          credentialDbIdsByHostname: Caml_option.some(playbackValues.credentialDbIdsByHostname),
          status: /* Running */0,
          failureId: undefined
        };
}

function t_encode$4(v) {
  return Js_dict.fromArray([[
                "playbackValues",
                Decco.optionToJson((function (param) {
                        return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(PlaybackParamValue$SmartcutsMacros.Update.t_encode, param);
                      }), v.playbackValues)
              ]]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var playbackValues = Decco.optionFromJson((function (param) {
          return CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(PlaybackParamValue$SmartcutsMacros.Update.t_decode, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict._0, "playbackValues"), null));
  if (playbackValues.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              playbackValues: playbackValues._0
            }
          };
  }
  var e = playbackValues._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".playbackValues" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function stringify(param) {
  return "{ playbackValues: " + (OptionUtils$SmartcutsMacros.stringify((function (map) {
                  return "{" + (Belt_Array.map(Belt_MapInt.toArray(map), (function (param) {
                                    return String(param[0]) + (" -> " + PlaybackParamValue$SmartcutsMacros.Update.stringify(param[1]));
                                  })).join(", ") + "}");
                }), param.playbackValues) + " }");
}

function apply(execution, param) {
  var arg = Belt_Option.map(param.playbackValues, (function (updates) {
          return Belt_Array.reduce(Belt_MapInt.toArray(updates), execution.playbackValues, (function (playbackValues, param) {
                        var update = param[1];
                        return Belt_MapInt.update(playbackValues, param[0], (function (maybeValue) {
                                      return Belt_Option.map(maybeValue, (function (value) {
                                                    var func = PlaybackParamValue$SmartcutsMacros.Update.apply;
                                                    return Curry._2(func, value, update);
                                                  }));
                                    }));
                      }));
        }));
  return {
          id: execution.id,
          taskId: execution.taskId,
          installedSmartcutId: execution.installedSmartcutId,
          createdAt: execution.createdAt,
          playbackValues: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })(execution.playbackValues),
          credentialDbIdsByHostname: execution.credentialDbIdsByHostname,
          status: execution.status,
          failureId: execution.failureId
        };
}

var Update = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify,
  apply: apply
};

var Execution = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  status_encode: status_encode$1,
  status_decode: status_decode$1,
  error_encode: error_encode,
  error_decode: error_decode,
  errorDetails_encode: errorDetails_encode,
  errorDetails_decode: errorDetails_decode,
  makeWithId: makeWithId,
  make: make$1,
  Update: Update
};

exports.ExecutionSet = ExecutionSet;
exports.Execution = Execution;
/* uuid Not a pure module */
